/* eslint-disable */
import { useEffect, useState, useRef } from "react";

// react-router-dom components
import { Link, useHistory, useParams } from "react-router-dom";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Switch from "@mui/material/Switch";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SuiTypography from "components/SuiTypography";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
import SuiInput from "components/SuiInput";
import SuiSelect from "components/SuiSelect";
import SuiDatePicker from "components/SuiDatePicker";
import SuiEditor from "./SuiEditor";
import SuiButton from "components/SuiButton";
import SourceCard from "../SourceCard";

import { URL_SOURCEFILES } from "api/myslr";
import axios from "api/index";
import { useAuth } from "auth-context/auth.context";

// Soft UI Dashboard PRO React base styles
import borders from "assets/theme/base/borders";

// sweetalert2 components
import Swal from "sweetalert2";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import SuiDropzone from "./SuiDropzone";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import { TailSpin } from "react-loader-spinner";
import Modal from "react-modal";
import ReactPlayer from "react-player";
import wosTutorial from "assets/tutorial/wos_import.mp4";

// Images
import filePreview from "assets/pics/xls-file.png";

function WosBox({ querystring_id, reload, isQueryOwner }) {
  const { borderWidth, borderColor } = borders;
  const { user } = useAuth();
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(true);
  const [isHowtoOpened, setIsHowtoOpened] = useState(false);
  const [sourcefileData, setSourcefileData] = useState(null);

  const [fileData, setFileData] = useState({
    filename: "",
    filesize: 0,
  });

  const [newFileData, setNewFileData] = useState({
    sourcefile_querystring: querystring_id,
    sourcefile: null,
    sourcefile_db: "wos",
    sourcefile_query_used: "",
  });

  const [error, setError] = useState(null);
  const [open, setOpen] = useState(false);

  // ✅ Import tracking
  const [importJob, setImportJob] = useState(null);
  const [importLogs, setImportLogs] = useState([]);
  const pollRef = useRef(null);

  const URL_IMPORTJOBS = "/v1/importjob";
  const LS_KEY = `importjob:wos:${querystring_id}`;

  const handleClickOpen = () => setOpen(true);
  const handleTutorialOpen = () => setIsHowtoOpened(true);

  // Modal.setAppElement("body");
  Modal.setAppElement(document.getElementById("body") || "body");

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };

  const stopPolling = () => {
    if (pollRef.current) {
      clearTimeout(pollRef.current);
      pollRef.current = null;
    }
  };

  const handleFetch = () => {
    axios
      .get(`${URL_SOURCEFILES}?sourcefile_querystring=${querystring_id}&sourcefile_db=wos`, {
        headers: { Authorization: `${user.token}` },
      })
      .then((response) => {
        setSourcefileData(response.data[0]);
        setIsLoading(false);
        reload();
      })
      .catch((_error) => {
        setError(_error);
        setIsLoading(false);
      });
  };

  const pollJob = (jobId) => {
    stopPolling();

    const headers = { Authorization: `${user.token}` };

    const tick = () => {
      Promise.all([
        axios.get(`${URL_IMPORTJOBS}/${jobId}`, { headers }),
        axios.get(`${URL_IMPORTJOBS}/${jobId}/logs?limit=200`, { headers }),
      ])
        .then(([jobRes, logsRes]) => {
          const job = jobRes.data;

          const logs = Array.isArray(logsRes.data) ? logsRes.data : logsRes.data?.results || [];
          const ordered = [...logs].reverse(); // più “umano”: ultimi in basso

          setImportJob(job);
          setImportLogs(ordered);

          if (job.status === "done") {
            localStorage.removeItem(LS_KEY);
            stopPolling();
            handleFetch();
            return;
          }

          if (job.status === "failed") {
            stopPolling();
            localStorage.removeItem(LS_KEY);

            const lastErr = [...ordered]
              .slice()
              .reverse()
              .find(
                (l) =>
                  String(l.level).toUpperCase() === "ERROR" &&
                  l.row_index !== null &&
                  l.row_index !== undefined
              );

            const msg = lastErr
              ? `Il file contiene un errore alla riga ${lastErr.row_index}. Correggi e ricarica.`
              : job.message || "Import fallito. Correggi il file e riprova.";

            Swal.fire("Import failed", msg, "error");

            // reset UI per permettere nuovo upload
            setImportJob(null);
            setImportLogs([]);
            return;
          }

          pollRef.current = setTimeout(tick, 800);
        })
        .catch(() => {
          pollRef.current = setTimeout(tick, 1200);
        });
    };

    tick();
  };

  const startImportTracking = (jobId) => {
    localStorage.setItem(LS_KEY, JSON.stringify({ job_id: jobId, ts: Date.now() }));
    setImportJob({
      id: jobId,
      status: "queued",
      progress_current: 0,
      progress_total: 0,
      message: "In attesa…",
    });
    setImportLogs([]);
    pollJob(jobId);
  };

  useEffect(() => {
    handleFetch();

    // ✅ se c’è un job attivo salvato, riprendi
    try {
      const raw = localStorage.getItem(LS_KEY);
      if (raw) {
        const { job_id } = JSON.parse(raw);
        if (job_id) pollJob(job_id);
      }
    } catch (e) {}

    return () => {
      stopPolling();
    };
    // eslint-disable-next-line
  }, []);

  const handleSave = () => {
    setIsLoading(true);
    setOpen(false);

    const formData = new FormData();

    let used_query = (newFileData.sourcefile_query_used || "").replace(/&nbsp;/g, " ");

    formData.append("sourcefile", newFileData.sourcefile);
    formData.append("sourcefile_querystring", newFileData.sourcefile_querystring);
    formData.append("sourcefile_db", newFileData.sourcefile_db);

    if (used_query !== "") {
      formData.append("sourcefile_query_used", used_query.replace(/(<([^>]+)>)/gi, ""));
    } else {
      formData.append("sourcefile_query_used", "None");
    }

    axios
      .post(URL_SOURCEFILES, formData, {
        headers: { Authorization: `${user.token}`, "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        const jobId = response.data?.job_id;

        if (jobId) {
          startImportTracking(jobId);
        } else {
          // fallback: se non arriva job_id, comportamento vecchio
          handleFetch();
        }

        setIsLoading(false);
      })
      .catch((_error) => {
        setIsLoading(false);
        setError(_error);

        const msg =
          _error?.response?.data?.detail ||
          _error?.response?.data?.sourcefile?.[0] ||
          _error?.response?.data?.non_field_errors?.[0] ||
          _error?.message ||
          "Upload failed";

        Swal.fire("Import error", msg, "error");
      });
  };

  const handleClose = () => setOpen(false);

  const handleDelete = () => {
    const newSwal = Swal.mixin({
      customClass: {
        confirmButton: "button button-success",
        cancelButton: "button button-error",
      },
      buttonsStyling: false,
    });

    newSwal
      .fire({
        title: "Are you sure?",
        text: "Web of Science dataset will be lost. You won't be able to revert this!",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.value) {
          axios
            .delete(`${URL_SOURCEFILES}/${sourcefileData.id}`, {
              headers: { Authorization: `${user.token}` },
            })
            .then((response) => {
              if (response.status == 204) {
                handleFetch();
              } else {
                newSwal.fire("Error!", "We can't delete your sourcefile", "error");
              }
            })
            .catch((_error) => setError(_error));
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          newSwal.fire("Cancelled", "File safe!", "error");
        }
      });
  };

  const handleQueryChange = (event) => {
    setNewFileData((prevState) => ({
      ...prevState,
      sourcefile_query_used: event,
    }));
  };

  const Uploader = () => (
    <SuiDropzone
      options={{
        addRemoveLinks: true,
        uploadMultiple: false,
        init: function () {
          this.on("addedfile", (file) => {
            setNewFileData((prevState) => ({ ...prevState, sourcefile: file }));
          });
          this.on("complete", (file) => {
            setFileData((prevState) => ({
              filename: file.name,
              filesize: (file.size / 1000000).toFixed(2),
            }));
          });
        },
      }}
    />
  );

  const Preview = () => (
    <SuiBox mt={2}>
      <SuiBox mb={1} lineHeight={0}>
        <SuiBox component="img" src={filePreview} alt="File preview" width={64} mb={3} />
        <SuiTypography component="label" variant="caption" fontWeight="bold">
          {fileData.filename}&nbsp;&nbsp;
          <SuiTypography variant="caption" fontWeight="regular" textColor="text">
            ({fileData.filesize} MB)
          </SuiTypography>
        </SuiTypography>
      </SuiBox>
    </SuiBox>
  );

  const LiveReader = () => (
    <SuiBox
      mt={2}
      p={2}
      borderRadius="xl"
      boxShadow="xxl"
      sx={{ border: "1px solid #eee", width: "100%" }}
    >
      <SuiBox display="flex" justifyContent="space-between" alignItems="center">
        <SuiBox>
          <SuiTypography fontWeight="bold">Import process: {importJob?.status}</SuiTypography>
          <SuiTypography variant="caption">{importJob?.message || "…"}</SuiTypography>
        </SuiBox>

        <SuiTypography variant="caption" fontWeight="bold">
          {importJob?.progress_total
            ? `${importJob.progress_current}/${importJob.progress_total}`
            : "…"}
        </SuiTypography>
      </SuiBox>

      <div
        style={{
          marginTop: 10,
          height: 10,
          background: "#f4f4f4",
          borderRadius: 999,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: importJob?.progress_total
              ? `${Math.round((importJob.progress_current / importJob.progress_total) * 100)}%`
              : "0%",
            height: "100%",
            background: "#222",
          }}
        />
      </div>

      <div
        style={{
          marginTop: 12,
          maxHeight: 260,
          overflow: "auto",
          background: "#fafafa",
          borderRadius: 10,
          padding: 10,
        }}
      >
        {importLogs.length === 0 ? (
          <div style={{ fontSize: 13, opacity: 0.7 }}>Waiting for log...</div>
        ) : (
          importLogs.map((l) => (
            <div
              key={l.id}
              style={{ fontSize: 13, padding: "4px 0", borderBottom: "1px solid #f0f0f0" }}
            >
              <b style={{ marginRight: 8 }}>{l.level}</b>
              {l.row_index !== null && l.row_index !== undefined ? (
                <span style={{ opacity: 0.7, marginRight: 8 }}>riga {l.row_index}</span>
              ) : null}
              <span>{l.message}</span>
            </div>
          ))
        )}
      </div>
    </SuiBox>
  );

  return (
    <SuiBox>
      <Grid container spacing={3} justifyContent="center" direction="column" alignItems="center">
        <Grid item xs={12}>
          <Divider />

          {isLoading ? (
            <TailSpin />
          ) : importJob && (importJob.status === "queued" || importJob.status === "running") ? (
            <LiveReader />
          ) : sourcefileData ? (
            <Grid item xs={12}>
              <SourceCard data={sourcefileData} handleDelete={handleDelete} />
            </Grid>
          ) : isQueryOwner ? (
            <SuiBox
              height="100%"
              display="flex"
              flexDirection="column"
              justifyContent="flex-end"
              alignItems="center"
              borderRadius="xl"
              boxShadow="xxl"
              border={`${borderWidth[1]} dashed ${borderColor}`}
              textAlign="center"
              p={3}
            >
              <SuiTypography>Please import a .xls file exported from Web of Science</SuiTypography>

              <Grid item xs={12}>
                <div onClick={handleClickOpen}>
                  <SuiBox
                    backgroundColor="info"
                    borderRadius="50%"
                    width="3.625rem"
                    height="3.625rem"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    color="white"
                    mx="auto"
                    backgroundGradient
                    customClass="cursor-pointer"
                  >
                    <Icon className="" fontSize="small">
                      add
                    </Icon>
                  </SuiBox>
                </div>

                <div onClick={handleTutorialOpen}>
                  <SuiBox
                    width="100%"
                    display="flex"
                    flexDirection="row"
                    justifyContent="flex-end"
                    alignItems="left"
                    textAlign="left"
                    p={1}
                  >
                    <SuiButton buttonColor="success" size="small">
                      How to export a research file from Web of Science
                    </SuiButton>
                  </SuiBox>
                </div>

                <Dialog open={open} onClose={handleClose} maxWidth={false}>
                  <DialogTitle>Add new file</DialogTitle>
                  <DialogContent>
                    <SuiBox>
                      <SuiBox mt={3}>
                        <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                          <SuiTypography component="label" variant="caption" fontWeight="bold">
                            File
                          </SuiTypography>
                        </SuiBox>
                        {newFileData.sourcefile ? <Preview /> : <Uploader />}
                      </SuiBox>

                      <SuiBox mt={2}>
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={12}>
                            <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                              <SuiTypography component="label" variant="caption" fontWeight="bold">
                                Used query&nbsp;&nbsp;
                                <SuiTypography
                                  variant="caption"
                                  fontWeight="regular"
                                  textColor="text"
                                >
                                  (optional)
                                </SuiTypography>
                              </SuiTypography>
                            </SuiBox>

                            <SuiEditor
                              value={newFileData.sourcefile_query_used}
                              placeholder="Insert used query..."
                              onChange={handleQueryChange}
                            />
                          </Grid>
                        </Grid>
                      </SuiBox>
                    </SuiBox>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleSave}>Save</Button>
                  </DialogActions>
                </Dialog>
              </Grid>
            </SuiBox>
          ) : (
            <SuiBox
              height="100%"
              display="flex"
              flexDirection="column"
              justifyContent="flex-end"
              alignItems="center"
              borderRadius="xl"
              boxShadow="xxl"
              border={`${borderWidth[1]} dashed ${borderColor}`}
              textAlign="center"
              p={3}
            >
              <SuiTypography>No files were uploaded for Web of Science</SuiTypography>
            </SuiBox>
          )}
        </Grid>
      </Grid>

      <Modal
        isOpen={isHowtoOpened}
        onRequestClose={() => setIsHowtoOpened(false)}
        style={customStyles}
      >
        <div>
          <ReactPlayer url={wosTutorial} playing={true} controls={true} loop={true} />
        </div>
      </Modal>
    </SuiBox>
  );
}

export default WosBox;
